import { createFeature, createReducer, on } from '@ngrx/store';
import { consentUrlsLoaded } from '../actions/consent-urls.actions';
import { StoredConsentUrls } from '@core/data/consent-urls/models/consent-urls.model';

export const CONSENT_URLS = 'consent-urls';

const initialState: StoredConsentUrls = {
  'consents.version': '',
  consents: {},
};

const reducer = createReducer(
  initialState,
  on(consentUrlsLoaded, (state, { consentUrlsLoaded }) => ({
    ...state,
    ...consentUrlsLoaded,
  })),
);

export const consentUrlsFeature = createFeature({
  name: CONSENT_URLS,
  reducer,
});
